// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2f1ba5cb","937":"b64fe36e"}[chunkId] + ".chunk.js";
};